import React from 'react';
import Flickity from 'react-flickity-component';

class ImageSlider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sliderReady: false
    }
  }
  // componentDidMount = () => {
  //   // this.flkty.on('lazyLoad', (e) => {
  //   //   this.setState({
  //   //     sliderReady: true
  //   //   })
  //   // })
  // }

  handleFirstImageLoaded() {
    this.setState({
      sliderReady: true
    })
  }

  render() {
    const flickityOptions = {
      initialIndex: 0,
      pageDots: false,
      wrapAround: true,
      lazyLoad: 1,
      autoPlay: 3000,
      cellSelector: '.carousel-cell',
      draggable: true,
      pauseAutoPlayOnHover: false
    }
    const slides = this.props.slides;

    return (
      <div className={`image-slider ${this.state.sliderReady ? 'ready' : ''}`}>
        <div className="flickity-cnt" rel="flickity_cnt">
          <Flickity flickityRef={c => this.flkty = c}
                    className={'carousel'} // default ''
                    elementType={'div'} // default 'div'
                    options={flickityOptions} // takes flickity options {}
                    disableImagesLoaded={false} // default false  // style={{backgroundImage:'url(' + slide.slide.url + ')'}}
                    imagesLoaded={true}
                     >
            {slides.map((slide, i) => {
              return <div key={i} className="slide carousel-cell">
                <img data-flickity-lazyload={slide.slide.url} alt={slide.slide.alt} onLoad={i===0 ? this.handleFirstImageLoaded.bind(this) : null} />
              </div>
            })}
          </Flickity>
        </div>
      </div>
    );
  }
}

export default ImageSlider;



// WEBPACK FOOTER //
// ./src/scripts/components/image-slider.js